import { Permission } from '@macs-gql';
import { inject } from '@angular/core';
import { CurrentUserService } from '@macs-frontend/core/services/current-user.service';
import { rx } from '@macs-frontend/core/utils/rx';
import { notEmpty } from '@macs-frontend/core/utils/typescript';
import { getUserPermissionsMap } from '@macs-frontend/reducers/meta';
import { Router } from '@angular/router';
import { KeycloakService } from '../services/keycloak.service';

export const createUserPermissionGuard = (permission: Permission) => {
  return () => {
    const currentUserService = inject(CurrentUserService);
    currentUserService.loadUser();
    const router = inject(Router);
    const keycloak = inject(KeycloakService);

    return currentUserService.user$.pipe(
      rx.filter(user => !!user.uuid),
      rx.map(user => {
        const userPermissions = getUserPermissionsMap(user);
        const result = !!userPermissions[permission];

        if (!result) {
          const hasAnyPermission = Object.values(Permission).some(
            p => !!userPermissions[p],
          );
          if (!hasAnyPermission && keycloak.enabled) {
            // Zero permissions here means the user is not a member of THIS
            // tenant at all (e.g. SSO'd in from another tenant's session).
            // Offer an explicit account switch: Keycloak cannot show a login
            // form that accepts a DIFFERENT user while an SSO session exists
            // (prompt=login only re-authenticates the current user), so
            // switching requires ending the session — which must stay the
            // user's explicit choice, not a side effect of visiting.
            router.navigate(['/switch-account']);
          } else {
            console.error(`User needs to have ${permission} permission`);
            router.navigate(['/access-denied']);
          }
        }

        return result;
      }),
    );
  };
};
